import { makeStyles } from "@fluentui/react-components";
export const usePublishPlanAsTemplateModalStyles = makeStyles({
    root: {
        maxWidth: "600px"
    }
});
